export default __webpack_public_path__ + "static/media/page-not-found.183bd90c.svg";